import React from 'react';
import { apiGetForumPost, apiIsLoggedIn } from '../api/api';
import { Link, useParams } from 'react-router-dom';
import TopBarForum from '../components/topbars/TopBarForum';
import { timestampToDateString, timestampToTimeString } from '../utility/date_functions';
import CommentCard from '../components/cards/CommentCard';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class PostPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            title: null,
            body: null,
            timestamp: null,
            user: null,
            comments: null,
        }
    }

    async componentDidMount() {
        const isLoggedIn = await apiIsLoggedIn();
        if (!isLoggedIn) {
            window.href = '/';
        }

        const postResponse = await apiGetForumPost(this.props.params.uuid);
        if (!postResponse.ok) {
            return;
        }

        const postJson = await postResponse.json();

        const post = postJson.post;

        this.setState({
            ...this.state,
            title: post.Title,
            body: post.Body,
            timestamp: post.TimeStamp,
            user: post.User,
            comments: postJson.comments,
        });
    }

    render() {
        const dateString = timestampToDateString(this.state.timestamp);
        const timeString = timestampToTimeString(this.state.timestamp);

        return (
            <div>
                <TopBarForum />
                {this.state.title ? 
                    <h3>{this.state.title}</h3>
                : null}
                <p style={{fontStyle: 'italic'}}>Posted {dateString} {timeString} by {this.state.user}</p>
                {this.state.body ?
                    <p>{this.state.body}</p>
                : null}
                <hr />
                <h5><Link to={`/post/${this.props.params.uuid}/comment`}>Add Comment</Link></h5>
                <h4>Comments:</h4>
                {this.state.comments && this.state.comments.length > 0 ?
                    <div>
                        {this.state.comments.map((comment) => {
                            return (<CommentCard key={comment.UUID} timestamp={comment.TimeStamp} user={comment.User} body={comment.Body} />);
                        })}
                    </div>
                : <p>No comments yet!</p>}
            </div>
        )
    }
}

export default withParams(PostPage);
